// extracted by mini-css-extract-plugin
module.exports = {"back-btn":"back-btn_back-btn__3Ivoa","icon":"back-btn_icon__3O-aw","span-style":"back-btn_span-style__2y1FD","logout-button":"back-btn_logout-button__3t4b6"};